<script lang="ts">
	import { onMount } from "svelte";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	export let hasPanel = false;

	const { COOKIES } = getGlobalSettings();

	function toggleBottomCartClass(hasPanel: boolean): void {
		const badge = document.getElementById("cookiescript_badge");
		if (badge) {
			badge.classList.toggle("bottom-cart", hasPanel);
		}
	}

	function toggleInjectedCartClass(hasPanel: boolean): void {
		const injected = document.getElementById("cookiescript_injected");
		if (injected) {
			injected.classList.toggle("injected-cart", hasPanel);
		}
	}

	function updateClasses(hasPanel: boolean): void {
		toggleBottomCartClass(hasPanel);
		toggleInjectedCartClass(hasPanel);
	}

	let loaded = false;
	function loadScript(): void {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.charset = "UTF-8";
		script.src = `https://cdn.cookie-script.com/s/${COOKIES}.js`;
		script.fetchPriority = "low";
		document.head.appendChild(script);

		function onLoad(): void {
			setTimeout(() => {
				updateClasses(hasPanel);
				const observer = new MutationObserver(() => {
					updateClasses(hasPanel);
				});
				observer.observe(document.body, { childList: true });
				loaded = true;
			});
			script.removeEventListener("load", onLoad);
		}
		script.addEventListener("load", onLoad);
	}

	onMount(() => {
		loadScript();
	});

	$: {
		if (loaded) {
			updateClasses(hasPanel);
		}
	}

	/* eslint-disable svelte/no-at-html-tags */
</script>

<style lang="postcss">
	:global(#cookiescript_badge) {
		z-index: 40 !important;
	}
	:global(.bottom-cart) {
		bottom: 5rem !important;
		box-shadow: 0 0 0 transparent !important;

		@media screen and (min-width: 640px) {
			bottom: 4.25rem !important;
		}
	}
	:global(.injected-cart) {
		bottom: 6rem !important;
		max-height: calc(100dvh - 7rem) !important;

		@media screen and (min-width: 640px) {
			bottom: 5.25rem !important;
			max-height: calc(100dvh - 6.25rem) !important;
		}
	}
</style>
